import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  PRINCIPALS_RESOURCE,
  PRINCIPAL_RESOURCE,
  UPDATE_PRINCIPAL_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_PRINCIPAL_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.principals(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: `${PRINCIPALS_RESOURCE}_${body.organisation.id}`,
            idProp: 'id',
            id,
          },
          setOther: {
            resource: PRINCIPAL_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updatePrincipalFailed'),
            onSuccessMessage: t('updatePrincipalSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
